import { ApiProperty } from "@nestjs/swagger";

export class ShiftReq {

    @ApiProperty()
    shift: string;

}